import { Linkable } from '@/components/blocks/Linkable';
import { Img } from '@/components/blocks/MaterialImage';
import { ProgressIndicator } from '@/components/blocks/ProgressIndicator';
import { useCategory } from '@/data/Content/Category';
import { useSeriesBySeries } from '@/data/Content/Series';
import { ID } from '@/data/types/Basic';
import { Box, Stack, Typography } from '@mui/material';
import { DimensionList } from 'presentation/components/fiwe/widgets/CategoryMarketingConceptWidget';
import {
	seriesColorSX,
	seriesColorTextSX,
	seriesColorWrapperSX,
} from 'presentation/components/fiwe/widgets/CategorySeriesProductListWidget/styles/seriesColor';
import { FC } from 'react';

export const CategorySeriesProductListWidget: FC<{ id: ID }> = ({ id }) => {
	const { category, loading } = useCategory(id);
	const { colors, isLoading } = useSeriesBySeries(category?.name ?? null);

	return (
		<Box id="CategorySeriesProductList">
			{loading || isLoading ? (
				<ProgressIndicator />
			) : (
				<Stack sx={seriesColorWrapperSX}>
					{colors?.map((color) => (
						<Linkable href={color.link} key={color.catentryId} sx={seriesColorSX({})}>
							<Img src={color.image} alt={color.name} width={150} height={150} />
							<Typography sx={seriesColorTextSX}>{color.name}</Typography>
							<DimensionList catentryId={color.catentryId} />
						</Linkable>
					))}
					{[...Array(5)].map((x, i) => (
						<Box sx={seriesColorSX({})} key={i}></Box>
					))}
				</Stack>
			)}
		</Box>
	);
};
